module.exports = __webpack_public_path__ + "static/media/lenka_kucerova.e00f0c80.png";